export default __webpack_public_path__ + "static/home_ss14-b29a3fcb329a6679448598dbec9aefe4.webp";